import React from 'react';
import styled from 'styled-components';

export type IconType = keyof typeof leftShapeMap;
// export const iconTypes: IconType[] = Object.keys(icons) as IconType[];

export const leftShapeMap = {
  1: 'M43 76C43 76 39 70.5 34 70.5C29 70.5 26 72.5 26 72.5',
  2: 'M56.0013 73.4301C56.0013 73.4301 58.5 70.5 64.5 71C70.5 71.5 73.2897 74.9658 73.2897 74.9658',
  3: 'M72.9623 67.1791C72.9623 67.1791 69.148 65.7546 63.5466 67.9624C57.9452 70.1701 56.7803 73.4553 56.7803 73.4553C60.3566 73.3885 68.5873 73.7265 72.8995 75.6124',
  4: 'M56.6141 74.1727C56.6141 74.1727 62.9391 70.5 68 70.5C73.0609 70.5 73.9703 74.2836 73.9703 74.2836',
};

export const leftEyelidShapeMap = {
  1: 'M43.5 72C41 67.5 34.5 64.5 27.5 68.5',
  2: 'M56 69C59.6883 65.4088 69.997 66.7966 73.5 71',
  3: 'M69 62.5C62 62.5 58.003 65.2966 54.5 69.5',
  4: 'M56.1166 70.278C59.4976 66.3961 71 64 74.0001 69',
};

export const rightShapeMap = {
  1: 'M57 76C57 76 61 70.5 66 70.5C71 70.5 74 72.5 74 72.5',
  2: 'M43.9404 73.4301C43.9404 73.4301 41.4416 70.5 35.4416 71C29.4417 71.5 26.6519 74.9658 26.6519 74.9658',
  3: 'M27.3802 67.1791C27.3802 67.1791 31.1945 65.7546 36.7959 67.9624C42.3973 70.1701 43.5623 73.4553 43.5623 73.4553C39.9859 73.3885 31.7552 73.7265 27.4431 75.6124',
  4: 'M43.9084 74.1727C43.9084 74.1727 37.5834 70.5 32.5225 70.5C27.4615 70.5 26.5522 74.2836 26.5522 74.2836',
};

export const rightEyelidShapeMap = {
  1: 'M56.5 72C59 67.5 65.5 64.5 72.5 68.5',
  2: 'M43.9417 69C40.2534 65.4088 29.9447 66.7966 26.4417 71',
  3: 'M31.3426 62.5C38.3426 62.5 42.3395 65.2966 45.8425 69.5',
  4: 'M44.4058 70.278C41.0248 66.3961 29.5225 64 26.5224 69',
};

export interface Props {
  icon: IconType | string;
  strokeWidth?: number;
  color?: string;
  eyelidColor?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function SmileEyes({ icon, strokeWidth, color, eyelidColor }: Props) {
  return (
    <>
      {/* left */}
      <g className="smile">
        <path
          d={leftShapeMap[icon]}
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={leftEyelidShapeMap[icon]}
          stroke={eyelidColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      {/* right */}
      <g className="smile">
        <path
          d={rightShapeMap[icon]}
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={rightEyelidShapeMap[icon]}
          stroke={eyelidColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  );
}

export default SmileEyes;
